<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import StrategyResultCardScaffold from './StrategyResultCardScaffold.vue';
import type { CalculationMode } from '@fire-calc/domain-ts';

interface Props {
  mode: CalculationMode;
  heroLabel: string;
  heroUnit: string;
  heroValue: string;
  heroSuffix?: string;
  bridgeText: string;
  fireNumber: string;
  fireNumberTooltip?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  fireNumberTooltip: '',
});

const resolvedFireNumberTooltip = computed<string>(() => props.fireNumberTooltip ?? '');
const { t } = useI18n();
</script>

<template>
  <StrategyResultCardScaffold
    tone="dwz"
    title="Die With Zero"
    :subheader="t('resultDWZDesc')"
    :hero-unit="heroUnit"
    :hero-label="heroLabel"
    :hero-value="heroValue"
    :hero-suffix="heroSuffix ?? ''"
    :bridge-text="bridgeText"
    :fire-number="fireNumber"
    :fire-number-tooltip="resolvedFireNumberTooltip"
  />
</template>
